import { useMutation, useQueryClient } from '@tanstack/react-query';
import { putUsersMe } from '../../../../api/user/mutations/putUsersMe';

export const usePutUsersMeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(putUsersMe, {
    onSuccess: () => queryClient.invalidateQueries(['users_me']),
  });
};
